import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
export const COMPLETED_CLASSIFICATIONS = "COMPLETED_CLASSIFICATIONS";
export const OUTSTANDING_CLASSIFICATIONS = "OUTSTANDING_CLASSIFICATIONS";
export const CURRENT_USER_DETAILS = "CURRENT_USER_DETAILS";
export const SESSION_TOKEN = "SESSION_TOKEN";
const getters = {
  [SESSION_TOKEN]: state => {
    return state.token;
  },
  [COMPLETED_CLASSIFICATIONS]: state => {
    var _classifications$allI, _classifications$allI2;
    const classifications = state.classifications;
    const documents = state.documents;
    return (_classifications$allI = (_classifications$allI2 = classifications.allIds) == null ? void 0 : _filterInstanceProperty(_classifications$allI2).call(_classifications$allI2, documentRequestId => {
      var _classifications$byId;
      const classification = (_classifications$byId = classifications.byId) == null ? void 0 : _classifications$byId[documentRequestId];
      const allCompleted = classification.documents.every(documentId => {
        var _documents$byId;
        return ((_documents$byId = documents.byId) == null ? void 0 : _documents$byId[documentId].requestStatus) === "complete";
      });
      return (classification == null ? void 0 : classification.sent) && (classification == null ? void 0 : classification.documents.length) && allCompleted;
    })) != null ? _classifications$allI : [];
  },
  [OUTSTANDING_CLASSIFICATIONS]: state => {
    var _classifications$allI3, _context;
    const classifications = state.classifications;
    const documents = state.documents;
    return (_classifications$allI3 = _filterInstanceProperty(_context = classifications.allIds).call(_context, documentRequestId => {
      var _classifications$byId2;
      const classification = (_classifications$byId2 = classifications.byId) == null ? void 0 : _classifications$byId2[documentRequestId];
      const someOutstanding = classification.documents.some(documentId => {
        var _documents$byId2;
        return ((_documents$byId2 = documents.byId) == null ? void 0 : _documents$byId2[documentId].requestStatus) !== "complete";
      });
      return classification.sent && (classification.documents.length === 0 || someOutstanding);
    })) != null ? _classifications$allI3 : [];
  },
  [CURRENT_USER_DETAILS]: state => {
    return _objectSpread(_objectSpread({}, state.clientDetails), {}, {
      username: state.clientDetails.clientUsername
    });
  }
};
export default getters;